module.exports = __webpack_public_path__ + "static/img/on11.8cfffcc4.png";